const locale = {
	INVENTURIUS: "Inventurius",
	OVERVIEW: "Overview",
	WELCOMEBACK: "Welcome back",
};

export default locale;
